import React from 'react';
import moment from 'moment-timezone';
import { withStyles } from "@material-ui/core";
import Button from '@material-ui/core/Button';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';


function styles(theme) {
	const bColor = theme.palette.grey[500];

	return {
		container: {
			display: 'flex',
			flexDirection: 'row',
			alignItems: 'center',
			border: `1px solid ${bColor}`,
			borderRadius: 5,
			height: 40,
		},
		today: {
			flex: 1,
			height: '100%',
			borderLeft: `1px solid ${bColor}`,
			borderRight: `1px solid ${bColor}`,
			textAlign: 'center',
			fontWeight: '500',
			padding: `0 15px`,
			color: '#555',
			fontSize: 15,
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			borderRadius: 'unset',
		},
		nav: {
			width: 30,
			alignItems: 'center',
			justifyContent: 'center',
			opacity: .7,
			borderRadius: 'unset',
			minWidth : 'unset',
		},
	};
}


class DateNavigation extends React.PureComponent {
	onLeft = () => {
		const { dateRangeOption, numberOfDays, startDate, onChange } = this.props;

		let newDate;
		if (dateRangeOption === 'oneMonth') {
			newDate = moment(startDate).subtract(1, 'month').format("YYYY-MM-DD");
		} else {
			const leftDays = Math.ceil(numberOfDays / 2);
			newDate = moment(startDate).subtract(leftDays, 'days').format("YYYY-MM-DD");
		}
		onChange(newDate);
	};

	onRight = () => {
		const { dateRangeOption, numberOfDays, startDate, onChange } = this.props;

		let newDate;
		if (dateRangeOption === 'oneMonth') {
			newDate = moment(startDate).add(1, 'month').format("YYYY-MM-DD");
		} else {
			const rightDays = Math.ceil(numberOfDays / 2);
			newDate = moment(startDate).add(rightDays, 'days').format("YYYY-MM-DD");
		}
		onChange(newDate);
	};

	onToday = () => {
		const { dateRangeOption, today, onChange } = this.props;

		let newDate;
		if (dateRangeOption === 'oneMonth') {
			newDate = moment(today).startOf('month').format('YYYY-MM-DD');
		} else {
			newDate = today;
		}

		onChange(newDate);
	};

	render () {
		const { classes } = this.props;
		return (
			<div className={classes.container}>
				<Button className={classes.nav} onClick={this.onLeft}><ChevronLeft /></Button>
				<Button className={classes.today} onClick={this.onToday}>TODAY</Button>
				<Button className={classes.nav} onClick={this.onRight}><ChevronRight /></Button>
			</div>
		)
	}
}

export default withStyles(styles)(DateNavigation);